import apiClient from '../apiClient';
import { PUT_RESTAURANT_ITEM_URL } from '../apiUrl';

const putRestaurantItemeApi = (id, data) => {
  return apiClient.put(PUT_RESTAURANT_ITEM_URL(id), data);
};

export default putRestaurantItemeApi;
